import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";


@Injectable()
export class DashboardService {
  constructor(private _networkService: NetworkService) { }

  getUserData() {
    return this._networkService.get("api/dashboard/userData", null, null, "bearer");

  }
  getCourseData() {
    return this._networkService.get("api/dashboard/courseData", null, null, "bearer");
  }

  getCoursePlanData() {
    return this._networkService.get("api/dashboard/coursePlanData", null, null, "bearer");
  }
  getReportedAnswereData() {
    return this._networkService.get("api/dashboard/reportedAnswers", null, null, "bearer");
  }
  getDashboardCount() {
    return this._networkService.get("api/dashboard/counts", null, null, "bearer");

  }

  getMonthlyUserDaily() {
    return this._networkService.get("api/dashboard/monthlyUserData", null, null, "bearer");
  }

  getMonthlyQuestion() {
    return this._networkService.get("api/dashboard/monthlyQuestionData", null, null, "bearer");
  }


}
